export const environment = {
    production: false,
    apiBase: "https://ym5l169gh0.execute-api.us-east-1.amazonaws.com/dev"
}